import { CMS_BASE_URL } from '../api/notice';

/** 格式化发布日期为 YYYY-MM-DD */
export function formatNoticeDate(value) {
  if (!value) return '';
  const text = String(value).trim();
  if (!text) return '';
  return text.slice(0, 10);
}

/**
 * 将 CMS 资源地址改写到固定域名。
 * 正文里常是 cmshop.xingsnb.cn，浏览器访问会裂图，需换成 192.168.66.62:72。
 */
export function rewriteCmsResourceUrl(url = '') {
  if (!url) return url;
  return String(url).replace(
    /https?:\/\/cmshop\.xingsnb\.cn\/prod-api/gi,
    CMS_BASE_URL
  );
}

/** 改写正文 HTML 中的图片、附件等资源地址 */
export function rewriteCmsHtmlResources(html = '') {
  if (!html) return html;
  return String(html).replace(
    /https?:\/\/cmshop\.xingsnb\.cn\/prod-api/gi,
    CMS_BASE_URL
  );
}

/** 去掉 HTML 标签，保留纯文本 */
function stripHtml(html = '') {
  return String(html)
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .trim();
}

/** 从正文 HTML 中提取可下载附件链接（优先用链接文字作为文件名） */
export function extractAttachmentsFromHtml(html = '') {
  if (!html) return [];

  const fileRe = /\.(pdf|docx?|xlsx?|zip|rar|7z)($|\?)/i;
  const seen = new Set();
  const attachments = [];
  const anchorRe = /<a\b[^>]*href=["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi;

  let match;
  while ((match = anchorRe.exec(html))) {
    const rawUrl = match[1];
    const url = rewriteCmsResourceUrl(rawUrl);
    if (!fileRe.test(url) || seen.has(url)) continue;
    seen.add(url);

    const linkText = stripHtml(match[2]);
    const clean = url.split('?')[0];
    const urlName = decodeURIComponent(clean.split('/').pop() || '附件');
    const extMatch = (linkText.match(/\.([^.]+)$/) || urlName.match(/\.([^.]+)$/));
    const ext = extMatch ? extMatch[1].toLowerCase() : 'file';

    // 链接文字有内容则用链接文字；若无扩展名则补上
    let name = linkText || urlName;
    if (linkText && !/\.[a-z0-9]+$/i.test(linkText) && ext && ext !== 'file') {
      name = `${linkText}.${ext}`;
    }

    attachments.push({
      name,
      url,
      ext,
    });
  }

  return attachments;
}

/** 列表项映射为页面结构 */
export function mapNoticeListItem(row) {
  return {
    id: row.contentId,
    contentId: row.contentId,
    catalogId: row.catalogId,
    slug: String(row.contentId),
    title: row.title || '',
    category: row.name || row.catalogName || '通知公告',
    date: formatNoticeDate(row.publishDate || row.createTime),
    viewCount: row.viewCount,
  };
}
